import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import InputMask from 'react-input-mask';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SchedulesStaffDifferenceTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      date: '',
      data_calculate_to_schedules_total_staff_differences: [],
      data_calculate_to_schedules_total_staff_differences_group: [],
    };
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.data_calculate_to_schedules_total_staff_differences !== 'undefined') {
      this.setState({
        data_calculate_to_schedules_total_staff_differences: newProps.data_calculate_to_schedules_total_staff_differences,
        data_calculate_to_schedules_total_staff_differences_group: newProps.data_calculate_to_schedules_total_staff_differences_group,
      });
    }
  }

  add(event) {
    event.preventDefault();
    this.props.addDataBase(this.state.date);
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-12 form-group">
        <label>Data-Base:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
      </div>

    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-success btn-lg btn-block">Mudar Data</button>
      </div>
    </div>
  </form>
  <hr/>
  <h4 className="pull-left">Total de Colaboradores</h4>
  <hr/>
  <BootstrapTable data={self.state.data_calculate_to_schedules_total_staff_differences} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn isKey={true} dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base</TableHeaderColumn>
    <TableHeaderColumn dataField="total_aircraft" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total aeronaves</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
    <TableHeaderColumn dataField="total_real" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total de Colaboradores - {this.state.date_fixed}</TableHeaderColumn>
    <TableHeaderColumn dataField="total_need" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total de Colaboradores - Orçamento</TableHeaderColumn>
    <TableHeaderColumn dataField="total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Diferença- Real vs Orçado</TableHeaderColumn>
  </BootstrapTable>
  <hr/>
  <h4 className="pull-left">Total de Colaboradores - Por grupo</h4>
  <hr/>
  <BootstrapTable data={self.state.data_calculate_to_schedules_total_staff_differences_group} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn isKey={true} dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Regime de Trabalho</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base</TableHeaderColumn>
    <TableHeaderColumn dataField="total_aircraft" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total aeronaves</TableHeaderColumn>
    <TableHeaderColumn dataField="size" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Porte</TableHeaderColumn>
    <TableHeaderColumn dataField="group" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Grupo</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
    <TableHeaderColumn dataField="total_real" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total de Colaboradores - Real</TableHeaderColumn>
    <TableHeaderColumn dataField="total_need" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total de Colaboradores - Orçamento</TableHeaderColumn>
    <TableHeaderColumn dataField="total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Diferença- Real vs Orçado</TableHeaderColumn>
  </BootstrapTable>
</div>
    );
  }
}

export default SchedulesStaffDifferenceTab;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesStaffDifferenceTab.js